import { regex } from 'react-admin';

const validateLei = regex(/^[A-Z0-9]{18}[0-9]{2}$/i, 'resources.lei.leiFormatError');
// todo validate checksum digits

export default validateLei;